import { Grid, Paper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MigaPan from '../../app/orussystem/component/MigaPan';
import PieChartQuetion from '../compoment/PieChartQuetion';
import { findResultPollById, findResultPollByIdBascula } from '../domain/apiClient';
import { Alert, AlertTitle } from '@material-ui/lab';





export const PollResult = (props) => {

    let { id, idBas } = useParams(); //id encuesta


    const [listResultPoll, setListResultPoll] = useState([]);
    const [tilesQuestion, setTilesQuestion] = useState([]);
    const [nameBascula] = useState("")
    const [data] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
        
        let res = idBas !== ":idBas" && idBas !== "" ? await findResultPollByIdBascula(id, idBas) : await findResultPollById(id);

            let idList = await res.resultPolls.map(m => {
                return m.id
            });

            var numQuetions = await idList.reduce((acc, item) => {
                if (!acc.includes(item)) {
                    acc.push(item);
                }
                return acc;
            }, [])
            let dw = await numQuetions.map(nq => {
                let d = res.resultPolls.filter(r => nq === r.id)
                return d;

            })

            let titles = await res.resultPolls.map(m => {
                return m.question
            });
            var tilesQuestion = await titles.reduce((acc, item) => {
                if (!acc.includes(item)) {
                    acc.push(item);
                }
                return acc;
            }, [])

            setTilesQuestion(tilesQuestion)

            let data = await dw.map(res => {

                return res.map(re => {
                    return { name: re.answer, value: re.count }
                })


            })

            setListResultPoll(data);
        }

        fetchData();
    }, [id, idBas]);


    return (
        <>


            {idBas === ":idBas" &&  <Grid item xs={12} >
            <br></br>
            <br></br>
                <MigaPan
                    namePage="Resultados"
                    to="/"
                    namePage2="Encuestas"
                    to2="/poll/encuestas/:id"

                >
                    Home
                </MigaPan>
            </Grid>}

            {idBas !== ":idBas" && idBas !== "" && <Grid item xs={12} >
            <br></br>
            <br></br>
                <MigaPan
                    namePage="Resultados"
                    to="/"
                    namePage3={`Encuestas ${nameBascula}`}
                    to3={`/poll/encuestas/${idBas}`}
                    namePage2="Estaciones"
                    to2="/basculas"

                >
                    Home
                </MigaPan>
            </Grid>}

            {listResultPoll.length === 0 &&

                <Grid item xs={12} md={12} lg={12}>
                    <Alert severity="warning">
                        <AlertTitle>Aun no hay rersultados</AlertTitle>
                        Esta encuesta aun no ha tenido respuestas — <strong>Vuelve pronto!</strong>
                    </Alert>
                </Grid>
            }

            {
                listResultPoll.map((lR, index) => {
                    return <Grid item xs={12} md={6} lg={6}>
                        <Paper style={{display: 'flex'}}>
                            <PieChartQuetion
                                data={lR}
                                data1={data}
                                title={tilesQuestion[index]}
                            />
                        </Paper>

                    </Grid>
                })
            }


        </>


    )



}